import foundationColorsOriginal from "./foundation-colors.json";
import systemColors from "./system-colors.json";
import { addHexOpacity } from "./utils";

const foundationColors = {
  ...foundationColorsOriginal,
  black: "#000000",
  white: "#ffffff",
};

/**
 * @deprecated This colors object is deprecated. Please use the objects foundationColors and systemColors directly.
 * Example:
 * import { foundationColors } from "@src/themes/colors";
 * import { systemColors } from "@src/themes/colors";
 *
 * Make sure the colors used are matching the designs in Figma
 * If a color is not available in the foundationColors or systemColors objects, please ask the design team to update the json files
 */
const colors = {
  lightGrey: "#ccc",
  lightGreyishBlue: "#e0e6ec",
  veryLightGrey: "#eee",
  lightestGray: "#f5f5f5",
  lightestEverGray: "#fafafa",
  midLightGrey: "#e4e4e4",
  midGrey: "#b3b3b3",
  darkGrey: "#9b9b9b",
  veryDarkGreyishViolet: foundationColors["deep-purple-600"],
  veryDarkGreyishBlue: "#343a40",
  veryDarkViolet: foundationColors["base-deep-purple"],
  lightGreyOpacity: "rgba(0, 0, 0, 0.45)",
  lightPurpleOpacity: "#e9e1f04d",
  lightGreen: systemColors["semantic-green-100"],
  darkLimeGreen: systemColors["semantic-green-500"],
  lightRed: systemColors["semantic-red-100"],
  darkRed: systemColors["semantic-red-500"],
  danger: systemColors["semantic-red-500"],
  reddishOrange: systemColors["semantic-red-500"],
  darkOrange: foundationColors["coral-900-base"],
  pureOrange: foundationColors["coral-700"],
  orangeYellow: foundationColors["coral-500"],
  lightestPurple: foundationColors["lavender-100"],
  lighterPurple: foundationColors["lavender-500"],
  lightPurple: foundationColors["deep-purple-100"],
  purple: foundationColors["deep-purple-500"],
  darkPurple: foundationColors["deep-purple-900"],
  midPurple: foundationColors["deep-purple-700"],
  lightBlue: "hsl(200, 75%, 75%)",
  white: foundationColors["white"],
  antiFlashWhite: foundationColors["lavender-100"],
  black: foundationColors["black"],
  almostBlack: foundationColors["base-deep-purple"],
  darkBlack: "rgba(0, 0, 0, 0.5)",
  veryLightGreyOpacity: "rgba(0, 0, 0, 0.25)",
  primaryPurple: foundationColors["base-deep-purple"],
  veryLightPurple: foundationColors["deep-purple-200"],
  cyan: "#348288",
  lightCyan: addHexOpacity("#BCDEDE", 30),
  veryLightCyan: foundationColors["lime-100"],
  pink: foundationColors["coral-500"],
};

export default colors;

export { foundationColors, systemColors };
